import { IValidation } from '../types';

export const validateNotEmpty = (value: string, fieldName: string): IValidation => {
  if (value !== undefined && value.trim().length > 0) {
    return {
      fieldName: fieldName,
      message: 'Gyldig',
      hasError: false,
    };
  } else {
    return {
      fieldName: fieldName,
      message: '',
      hasError: true,
    };
  }
};

export const validateIsOnlyNumbers = (value: string, fieldName: string, isRequired: boolean): IValidation => {
  const regEx = /(^[0-9]+)|(^$)/g;
  if (value.trim() === '' && isRequired) {
    return {
      fieldName: fieldName,
      message: '',
      hasError: true,
    };
  } else if (regEx.test(value.trim())) {
    return {
      fieldName: fieldName,
      message: 'Gyldig',
      hasError: false,
    };
  } else {
    return {
      fieldName: fieldName,
      message: 'Ugyldig',
      hasError: true,
    };
  }
};

export const validateEmail = (value: string, fieldName: string): IValidation => {
  const expression = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (value.trim() === '') {
    return {
      fieldName: fieldName,
      message: '',
      hasError: true,
    };
  } else if (expression.test(String(value).toLowerCase())) {
    return {
      fieldName: fieldName,
      message: 'Gyldig',
      hasError: false,
    };
  } else {
    return {
      fieldName: fieldName,
      message: 'Ugyldig',
      hasError: true,
    };
  }
};

export const validatePhoneNumber = (value: string, fieldName: string): IValidation => {
  const phoneNumLength = 8;
  const isValidLenght: boolean = validateNumLength(value, phoneNumLength);
  if (value.trim() === '') {
    return {
      fieldName: fieldName,
      message: '',
      hasError: true,
    };
  } else if (isValidLenght) {
    return {
      fieldName: fieldName,
      message: 'Gyldig',
      hasError: false,
    };
  } else {
    return {
      fieldName: fieldName,
      message: 'Ugyldig',
      hasError: true,
    };
  }
};

export const validateOrgNum = (orgNum: string, fieldName: string): IValidation => {
  const orgNumLength = 9;
  const isValidLenght: boolean = validateNumLength(orgNum, orgNumLength);
  const controlNumberDigit: number = parseInt(orgNum.charAt(orgNum.length - 1));
  const zeroSum = parseInt(orgNum) === 0;

  if (isValidLenght && mod11(orgNum) === controlNumberDigit && !zeroSum) {
    return {
      fieldName: fieldName,
      message: 'Gyldig',
      hasError: false,
    };
  } else {
    return {
      fieldName: fieldName,
      message: 'Ugyldig',
      hasError: true,
    };
  }
};

const validateNumLength = (num: string, length: number): boolean => num.length === length;

// MOD11 (Modulus11) er en kontrollsifferalgoritme som blant annet benyttes for å validere kontonumre i norske banker, organisasjonsnummer
// https://no.wikipedia.org/wiki/MOD11 (lenk inkludere et javascript eksempel)
const mod11 = function(input: string): number {
  let controlNumber: number = 2;
  let sumForMod: number = 0;

  for (let i: number = input.length - 2; i >= 0; --i) {
    sumForMod += parseInt(input.charAt(i)) * controlNumber;
    if (++controlNumber > 7) controlNumber = 2 as number;
  }
  const result: number = 11 - (sumForMod % 11);

  return result === 11 ? 0 : result;
};
